<interacta-dialog
    [isOpen]="data().isOpen"
    [size]="'regular'"
    [testId]="'user-profile-dialog'"
    (closing)="close()"
>
    @let _user = user();

    <ng-content title>
        @if (data().isFetching) {
            <div class="m-auto flex h-200 items-center">
                <interacta-loader [size]="'large'" />
            </div>
        } @else if (_user) {
            <div
                class="flex gap-x-24"
                title
                [ngClass]="{
                    'items-center': !canViewProfile(),
                }"
            >
                <interacta-avatar [size]="'large'" [user]="_user" />
                <div class="flex flex-col">
                    <span
                        class="line-clamp-2 typo-t5"
                        [matTooltip]="_user.fullName"
                    >
                        {{ _user.fullName }}
                    </span>
                    @if (_user.caption) {
                        <span class="typo-sm"> {{ _user.caption }} </span>
                    }
                    @if (_user.role) {
                        <span class="typo-sm">{{ _user.role }}</span>
                    }

                    @if (_user.deleted) {
                        <div
                            class="flex items-center gap-4 typo-sm text-text-primary"
                        >
                            <interacta-icon
                                class="size-24"
                                [icon]="'person-circle-off'"
                            />
                            <span>{{
                                (_user.blocked
                                    ? labelRoot + 'USER_BLOCKED'
                                    : labelRoot + 'USER_DELETED'
                                ) | translate
                            }}</span>
                        </div>
                    }

                    @if (isAdmin() || userIsCurrentUser() || canViewProfile()) {
                        <div class="mt-20 flex gap-x-18">
                            @if (
                                !userIsCurrentUser() &&
                                !_user.deleted &&
                                !isAdmin()
                            ) {
                                <button
                                    data-testid="user-profile-dialog-follow-button"
                                    interacta-toggle-button
                                    type="button"
                                    [icon]="'bell'"
                                    [label]="
                                        (_user.followedByMe
                                            ? labelRoot + 'ALREADY_FOLLOWING'
                                            : labelRoot + 'FOLLOW'
                                        ) | translate
                                    "
                                    [selected]="_user.followedByMe ?? false"
                                    [size]="'small'"
                                    (click)="
                                        $event.stopPropagation(); toggleFollow()
                                    "
                                ></button>
                            }
                            <a
                                data-testid="user-profile-dialog-full-profile-link"
                                interacta-button
                                type="button"
                                [label]="
                                    (isAdmin()
                                        ? labelRoot + 'GO_TO_PROFILE'
                                        : labelRoot + 'GO_TO_FULL_PROFILE'
                                    ) | translate
                                "
                                [routerLink]="profileLink()"
                                [size]="'small'"
                                [style]="'outlined'"
                            ></a>
                        </div>
                    }
                </div>
            </div>
        }
    </ng-content>

    @if (viewContent() && _user) {
        <div class="flex flex-col" content>
            @if (_user.biography) {
                <span class="typo-xs italic">{{ _user.biography }}</span>
            }
            <interacta-separator class="mt-16 mb-4" [thickness]="'strong'" />

            <div
                class="typo-sm-bold"
                data-testid="user-profile-dialog-contacts-title"
            >
                {{ 'SHARED.USER.CONTACT' | translate }}
            </div>
            <dl class="flex flex-col gap-y-8">
                @for (item of items(); track $index) {
                    <div
                        interactaKeyValueField
                        [attr.data-testid]="item.testId"
                        [hideSeparator]="$last"
                    >
                        <dt
                            class="w-160 text-text-mid-contrast"
                            data-testid="user-profile-field-term"
                        >
                            {{ item.label | translate }}
                        </dt>
                        <dd
                            class="min-w-0 grow"
                            data-testid="user-profile-field-value"
                        >
                            @switch (item.type) {
                                @case ('email') {
                                    <a
                                        class="text-text-primary"
                                        [href]="'mailto:' + item.value"
                                    >
                                        {{ item.value }}
                                    </a>
                                }
                                @case ('string') {
                                    <span>{{ item.value }}</span>
                                }
                            }
                        </dd>
                    </div>
                }
            </dl>
        </div>
    }
</interacta-dialog>
